interface ButtonProps {
  children: React.ReactNode;
  primary?: boolean;
  small?: boolean;
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
  type?: 'button' | 'submit';
}

export default function Button({ children, primary, small, disabled, className = '', onClick, type = 'button' }: ButtonProps) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        rounded-lg font-semibold tracking-wide transition-all
        ${small ? 'px-3.5 py-1.5 text-xs' : 'px-5 py-2.5 text-sm'}
        ${primary
          ? 'bg-primary text-white hover:bg-primary-hover border-none'
          : 'bg-transparent text-text-main border border-border hover:bg-surface-hover'
        }
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        ${className}
      `}
    >
      {children}
    </button>
  );
}
